export default __webpack_public_path__ + "static/media/SFProDisplay-Ultralight.38c7b0a1.woff";